export enum CrudFormValueEmitMode {
  ReturnAllValues = 'returnAllValues',
  ReturnDirtyValues = 'returnDirtyValues'
}
